/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tool_Risk_High_HintInputs */



/**
* | output |
* | --- |
* | "Changes data and can never hold a trust window — every single call is confirmed on its own." |
*
* @param {Tool_Risk_High_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tool_risk_high_hint = /** @type {((inputs?: Tool_Risk_High_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tool_Risk_High_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verändert Daten und kann nie ein Vertrauensfenster erhalten — jeder einzelne Aufruf wird einzeln bestätigt.")
	return /** @type {LocalizedString} */ ("Changes data and can never hold a trust window — every single call is confirmed on its own.")
});